import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store';
import { changeView, LayoutState } from 'store/layoutSlice';

import Button from 'layout/atoms/Button';

import { ReactComponent as GridIcon } from 'assets/icons/grid.svg';
import { ReactComponent as ListIcon } from 'assets/icons/list.svg';

const ViewToggler = () => {
    const dispatch = useDispatch<AppDispatch>();
    const layoutState: LayoutState = useSelector((state: any) => state.layout);

    const handleChange = () => {
        dispatch(changeView());
        // Save to localStorage immediately when user clicks
        const newView = layoutState.projectsView === 'list' ? 'grid' : 'list';
        console.log('ViewToggler: saving view to localStorage:', newView);
        localStorage.setItem('hustleView', newView);
    };

    return (
        <Button size="m" align="left" onClick={handleChange}>
            {layoutState.projectsView === 'list' ? <GridIcon /> : <ListIcon />}
            <span>
                {layoutState.projectsView === 'list'
                    ? 'Grid view'
                    : 'List view'}
            </span>
        </Button>
    );
};

export default ViewToggler;
